import dayjs, { type Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const getLocaleBasedDateFormats = (): string[] => {
  const locale = navigator.language || "en-US";
  const isUSLocale = locale.startsWith("en-US");

  if (isUSLocale) {
    return ["MM/DD/YYYY", "M/DD/YYYY", "MM/D/YYYY", "M/D/YYYY", "YYYY-MM-DD", "YYYY-MM-D", "YYYY-M-DD", "YYYY-M-D"];
  } else {
    return ["DD/MM/YYYY", "D/M/YYYY", "DD/M/YYYY", "D/MM/YYYY", "YYYY-MM-DD", "YYYY-M-DD", "YYYY-MM-D", "YYYY-M-D"];
  }
};

export const validateDateWithLocale = (value: string, validationFn: (date: Dayjs) => boolean): boolean => {
  if (!value) {
    return false;
  }

  const formats = getLocaleBasedDateFormats();

  for (const format of formats) {
    const parsed = dayjs(value, format, true);
    if (parsed.isValid()) {
      return validationFn(parsed);
    }
  }
  return false;
};

export const isFutureDate = (date: string): boolean => dayjs(date).isAfter(dayjs(), "day");

export const getIncorporationYearPickerRange = () => {
  const currentYear = new Date().getFullYear();
  return { min: currentYear - 100, max: currentYear };
};

export const parseAndFormatDate = (value: string): string => {
  const formats = getLocaleBasedDateFormats();

  for (const format of formats) {
    const parsed = dayjs(value, format, true);
    if (parsed.isValid()) {
      return parsed.format("YYYY-MM-DD");
    }
  }

  return dayjs(value).format("YYYY-MM-DD");
};
